import { TimePicker, type TimePickerProps } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';
import { useDatesLabels } from './dates.js';

export interface TimeInputProps
  extends Omit<TimePickerProps, 'value' | 'defaultValue' | 'onChange' | 'format' | 'withSeconds'> {
  /** Saat `SS:DD`, 24 saat; boşsa `''`. */
  value: string | null | undefined;
  onChange: (value: string) => void;
}

/**
 * Saat girişi (M6f G1-04; ADR 0033): saat ve dakika ayrı alanlarda, 24 saat (AM/PM yok). İşletim
 * sisteminin dil biçiminden bağımsızdır (yerel `<input type="time">` yerine).
 */
export function TimeInput({
  value,
  onChange,
  leftSection,
  rightSection,
  readOnly,
  ...rest
}: TimeInputProps) {
  const labels = useDatesLabels();
  const icon =
    leftSection || rightSection !== undefined || readOnly ? (
      rightSection
    ) : (
      <IconClock size={16} aria-hidden />
    );
  return (
    <TimePicker
      hoursInputLabel={labels.hoursInputLabel}
      minutesInputLabel={labels.minutesInputLabel}
      {...rest}
      format="24h"
      withSeconds={false}
      value={value ?? ''}
      onChange={onChange}
      readOnly={readOnly ?? false}
      leftSection={leftSection}
      rightSection={icon}
      {...(rest.clearable ? {} : { rightSectionPointerEvents: 'none' as const })}
    />
  );
}
